import { Button, Img, Text } from "components";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import * as CUSTOM from "../../../utils/helper/custom";
import { useDispatch, useSelector } from "react-redux";
import globalRequest from "../../../utils/global/globalRequest";
import { changeLoader } from "../../../redux/reducers/loader";
import * as APIS from "../../../utils/helper/Enum";
import { changeTrigger } from "../../../redux/reducers/trigger";
import styled from "styled-components";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
  updateOrderData,
  getOrderData,
} from "../../../redux/reducers/orderData";
import { useAppFont } from "utils/helper/useAppFont";

// HtmlTooltip — same as original CartProductDetail
const HtmlTooltip = styled(
  React.forwardRef(function HtmlTooltip(props, ref) {
    return (
      <Tooltip {...props} ref={ref} classes={{ popper: props.className }} />
    );
  })
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "transparent",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 300,
    margin: 0,
    padding: 0,
    ".MuiTooltip-arrow": {
      color: "#FFFFFF", // Arrow color
      width: "28px", // Arrow width
      height: "16px", // Arrow height
      bottom: "-8px", // Position where arrow is pointing
      left: "-9px !important", // Position where arrow is pointing
    },
  },
}));

// ContentWrapper — mirrors Cart's popup/desktop dual mode
const ContentWrapper = ({ children, isPopup, onClose }) => {
  if (isPopup) {
    return (
      <>
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9998]"
          onClick={onClose}
        />
        <div className="fixed inset-0 z-[9999] bg-[#ffffff] flex items-end sm:items-center justify-center p-0 sm:p-4">
          <div
            className="bg-white rounded-t-2xl sm:rounded-2xl w-full max-w-full sm:max-w-[400px] max-h-[90vh] overflow-y-auto pointer-events-auto shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-white z-10 px-4 py-3 border-b border-gray-200 flex items-center justify-between">
              <Text className="text-black-900 font-semibold text-base">
                Order Summary
              </Text>
              <button
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M15 5L5 15M5 5L15 15" stroke="#1A1A1A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
            {children}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="max-w-[350px] w-full sm:pl-0 xs:pl-0 sm:max-w-full sm:order-1">
      {children}
    </div>
  );
};

const CartProductDetail = ({ orderDetails, orderSummary, isPopup, onClose }) => {
  const { t } = useTranslation();
  const orderData = useSelector(getOrderData);
  const orderDetailsData = orderDetails?.orderData;
  const dispatch = useDispatch();
  const [prepTime, setPrepTime] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const { interClass, interFamily, headingClass, headingFamily } = useAppFont();

  const isReservationFlow = !!orderData?.isReservationFlow;
  const reservationData   = orderData?.reservationData || {};

  console.log("orderSummary-----------", orderSummary);
  /**
   * get group item name from order data
   */
  const getGroupItemName = (items) => {
    return items
      .map((item) =>
        CUSTOM.getdataByLangKey(item?.modifierGroupItemLocales, "", "name")
      )
      .join(", ");
  };

  /**
   * Apply coupon code
   */
  const applyCouponCode = async () => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        APIS?.CUSTOMCAKE?.APPLY_COUPON_CODE,
        "get",
        {},
        {
          params: {
            coupon_code: couponCode ? couponCode.trim() : "",
            order_id: orderDetailsData?.id,
            delivery_mode:
              orderData?.deliveryModeTabIndex == 2 ? "pickup" : "delivery",
            delivery_fees: CUSTOM.setPrice(orderSummary?.delivery_fees),
          },
        },
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        dispatch(
          updateOrderData({
            ...orderData,
            couponCode: couponCode.trim(),
            couponCodeId: response?.data?.data?.id,
          })
        );
        CUSTOM.trackCouponApplied({ coupon_code: couponCode.trim() });
        setCouponCode("");
        dispatch(changeTrigger("loadSummay"));
        return;
      } else {
        setCouponCodeError(response?.message);
      }
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  /**
   * remove coupon code
   */
  const removeCouponCode = () => {
    dispatch(changeLoader(true));
    dispatch(
      updateOrderData({ ...orderData, couponCode: "", couponCodeId: "" })
    );
    setCouponCode("");
    setTimeout(() => {
      dispatch(changeTrigger("loadSummay"));
      dispatch(changeLoader(false));
    }, [500]);
  };

  const isShowCouponCode = () => {
    if (orderData?.deliveryModeTabIndex == 1) {
      if (orderData?.pageStep == 4) return true;
    } else if (orderData?.deliveryModeTabIndex == 2) {
      if (orderData?.pageStep == 4) return true;
    } else if (orderData?.deliveryModeTabIndex == 3) {
      return false;
    }
    return false;
  };

  /**
   * get prep time from order details page
   */
  useEffect(() => {
    if (isReservationFlow) return;

    let totalTime = 0;
    orderDetailsData?.orderDetails?.forEach((oitem) => {
      oitem?.orderItemDetails?.cakeDetail?.forEach((orderIt) => {
        orderIt?.modifierGroupItems?.forEach((nitem) => {
          totalTime += nitem?.prepTime;
        });
      });
    });
    setPrepTime(CUSTOM.minutsToHour(totalTime));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails]);

  /**
   * apply coupon code when page reload
   */
  useEffect(() => {
    setCouponCode(orderData?.couponCode ? orderData?.couponCode : "");
  }, [orderData]);

  useEffect(() => {
    if (orderData?.couponCode) {
      if (!isShowCouponCode()) {
        removeCouponCode();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData]);

  const rawPrice  = isReservationFlow ? (Number(reservationData?.price) || 0) : 0;
  const basePrice = rawPrice / 1.15;
  const vatAmount = rawPrice - basePrice;

  return (
    <ContentWrapper isPopup={isPopup} onClose={onClose}>
      {/* ── Main card — Cart style: rounded-lg, shadow-sm, border ── */}
      <div className="bg-[#ffffff] rounded-lg shadow-sm border border-gray-200">

        {/* Card header */}
        {!isPopup && (
          <div className="px-4 py-3 border-b border-gray-200">
            <Text className="text-black-900 font-semibold text-base">
              {isReservationFlow ? "Reservation Summary" : "Order Details"}
            </Text>
          </div>
        )}

        {isReservationFlow ? (
          <>
            {/* Package card */}
            <div className="p-4 flex flex-col gap-3">
              <div className="flex items-start gap-3">
                <div className="w-16 h-16 flex-shrink-0 bg-pink-50 rounded-lg flex items-center justify-center">
                  <Img src="/images/cake.png" alt="package" className="w-10 h-10 object-contain" />
                </div>

                <div className="flex-1 min-w-0">
                  <Text className={`text-[#1A1A1A] font-medium text-sm leading-5 ${headingClass}`}>
                    {reservationData?.packageName || "Reservation Package"}
                  </Text>
                  <Text className={`text-[#727783] text-sm font-normal leading-5 mt-0.5 ${interClass}`}>
                    {reservationData?.slotLabel} &bull; {reservationData?.guests} Guests
                  </Text>
                  {reservationData?.date && (
                    <Text className={`text-[#727783] text-xs mt-0.5 ${interClass}`}>
                      {new Date(reservationData.date).toLocaleDateString("en-SA", {
                        weekday: "short", month: "short", day: "numeric",
                      })}
                    </Text>
                  )}
                </div>

                <div className="flex items-center gap-1 flex-shrink-0">
                  <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px]" />
                  <Text className={`text-[#1A1A1A] font-medium text-base ${headingClass}`}>
                    {reservationData?.price}
                  </Text>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-3 grid grid-cols-2 gap-2">
                {[
                  [<Img src="/images/clock.png" alt="hours"  className="w-[24px] h-[24px]" />, `${reservationData?.hours} Hours`],
                  [<Img src="/images/person.png" alt="people" className="w-[24px] h-[24px]" />, `Up to ${reservationData?.people} People`],
                  [<Img src="/images/chair.png"  alt="chairs" className="w-[24px] h-[24px]" />, `${reservationData?.chairs} Chairs`],
                  [<Img src="/images/cake.png"   alt="cakes"  className="w-[24px] h-[24px]" />, `${reservationData?.cakes} Cakes`],
                ].map(([icon, label]) => (
                  <div key={label} className="flex items-center gap-1">
                    <span className="text-sm">{icon}</span>
                    <Text className={`text-[#727783] text-xs ${interClass}`}>{label}</Text>
                  </div>
                ))}
              </div>
            </div>

            {/* Reservation price breakdown */}
            <div className="px-4 py-4 border-t border-gray-200">
              <Text className={`text-black ${headingClass} text-lg font-medium leading-6 mb-3`}>
                {t("orderSummary") || "Order Summary"}
              </Text>

              <div className="space-y-2">
                <div className="flex justify-between text-sm">
                  <Text
                    className={`text-center ${interClass} text-base font-normal leading-6`}
                    style={{ color: "var(--Blacks-400, #727783)" }}
                  >
                    {t("packagePrice") || "Package Price"}
                  </Text>
                  <div className="flex items-center gap-2">
                    <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                    <Text
                      className={`${headingClass} text-base font-medium leading-6`}
                      style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                    >
                      {t("sar")} {basePrice.toFixed(2)}
                    </Text>
                  </div>
                </div>

                {/* Delivery fee — 0 for reservation */}
                <div className="flex justify-between text-sm">
                  <Text
                    className={`text-center ${interClass} text-base font-normal leading-6`}
                    style={{ color: "var(--Blacks-400, #727783)" }}
                  >
                    {t("deliveryFee") || "Delivery Fee"}
                  </Text>
                  <div className="flex items-center gap-2">
                    <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                    <Text
                      className={`${headingClass} text-base font-medium leading-6`}
                      style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                    >
                      {t("sar")} 0.00
                    </Text>
                  </div>
                </div>

                {/* VAT */}
                <div className="flex justify-between text-sm">
                  <Text
                    className={`text-center ${interClass} text-base font-normal leading-6`}
                    style={{ color: "var(--Blacks-400, #727783)" }}
                  >
                    {t("taxVAT") || "Tax (VAT 15%)"}
                  </Text>
                  <div className="flex items-center gap-2">
                    <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                    <Text
                      className={`${headingClass} text-base font-medium leading-6`}
                      style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                    >
                      {t("sar")} {vatAmount.toFixed(2)}
                    </Text>
                  </div>
                </div>
              </div>

              {/* Total */}
              <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-300">
                <Text className={`text-black-900 ${interClass} text-base`}>
                  {t("totalAmount") || "Total"}
                </Text>
                <div className="flex items-center gap-2">
                  <Img src="/images/Groupsar.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                  <Text className={`text-[#771237] font-bold ${headingClass} text-lg`}>
                    {t("sar")} {rawPrice.toFixed(2)}
                  </Text>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
        {/* ── Estimated price + prep time banner (original custom cake info) ── */}
        <div className="px-5 py-4">
          <div className="bg-red-50_01 p-4 rounded w-full mb-5">
            <div className="flex flex-row items-start justify-between w-full">
              <div className="flex items-center">
                <Img className="h-6 object-contain w-6" src="/images/img_clock_black_900.svg" alt="clock" />
                <Text className="text-sm text-black-900 w-auto mx-2 font-nunitomedium font-normal">
                  {t("estimatedPriceColon")}
                </Text>
              </div>
              <Text className="text-sm text-gray-700 w-auto font-nunitoregular font-normal text-[16px]">
                SAR {CUSTOM.setPrice(orderDetailsData?.priceDetails?.total_amount)}
              </Text>
            </div>
            <div className="flex flex-row items-start justify-between w-full mt-3">
              <div className="flex items-center">
                <Img className="h-6 object-contain w-6" src="/images/img_television.svg" alt="television" />
                <Text className="text-sm text-black-900 w-auto mx-2 font-nunitomedium font-normal">
                  {t("estimatedPrepDotTimeColon")}
                </Text>
              </div>
              <Text className="text-sm text-gray-700 w-auto font-nunitoregular font-normal text-[16px]">
                {prepTime} hrs
              </Text>
            </div>
          </div>

          {/* ── Cake details list — original structure preserved ── */}
          <div className="flex flex-col w-full detail-box-height">
            {orderDetailsData?.orderDetails?.map((oitem, index) => (
              <div
                className="flex flex-col items-start justify-between w-full mb-6"
                key={`outer-${index}`}
              >
                {oitem?.orderItemDetails?.cakeDetail?.map((orderIt, oindex) => (
                  <div className="mb-6" key={`inner-${oindex}`}>
                    <Text className="font-nunitomedium text-base mb-1">
                      {CUSTOM.getdataByLangKey(
                        orderIt?.modifierGroupLocales,
                        "",
                        "name"
                      )}
                    </Text>
                    <Text className="font-nunitoregular text-sm text-black-900 leading-[24px]">
                      {getGroupItemName(orderIt?.modifierGroupItems)}
                    </Text>
                  </div>
                ))}

                {/* Reference image / link */}
                <div className="mb-6" key={`inner-23122413243`}>
                  <Text className="font-nunitomedium text-base mb-1">
                    {t("referenceImageSlashLink")}
                  </Text>
                  <div className="font-nunitoregular text-sm text-black-900 leading-[24px]">
                    <div className="flex flex-wrap flex-row gap-3 items-start justify-start w-full">
                      {oitem?.orderItemDetails?.imageLinks?.map((itemsLinks, ind) => (
                        <div className="key-value-map" key={`imgskey${ind}`}>
                          <Img
                            className="cursor-pointer h-[64px] w-[64px] object-cover rounded-lg"
                            src={itemsLinks}
                            alt="rectangle19120"
                            loading="lazy"
                          />
                        </div>
                      ))}
                    </div>
                    {oitem?.orderItemDetails?.referenceLink ? (
                      <Text
                        className="font-nunitoregular text-sm text-black-900 leading-[24px] underline mt-5"
                        style={{ textWrap: "pretty" }}
                      >
                        <a
                          href={oitem?.orderItemDetails?.referenceLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {oitem?.orderItemDetails?.referenceLink}
                        </a>
                      </Text>
                    ) : null}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Notes — Cart style textarea ── */}
          <div className="px-0 py-3 border-t border-gray-200">
            <textarea
              type="text"
              placeholder={t("anyNote?WriteHere") || "Do you have any note? Write here..."}
              value={orderData?.notes}
              onChange={(e) => {
                dispatch(
                  updateOrderData({
                    ...orderData,
                    notes: CUSTOM.strFormat(e.target.value, "max:250"),
                  })
                );
              }}
              className="w-full border border-gray-300 rounded-md p-2 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#BD0043]"
              rows="2"
            />
          </div>
        </div>

        {/* ── Coupon Code ── */}
        {isShowCouponCode() && (
          <div className="px-4 py-3 border-t border-gray-200">
            <div className="flex items-center border border-gray-300 rounded-full px-2 py-1">
              <div className="flex items-center flex-1 gap-2 px-2">
                <span className="text-pink-600 text-sm">
                  <Img className="h-5 w-5" src="/images/img_iconamoondiscountlight.svg" alt="coupon" />
                </span>
                <input
                  className={`w-full border-0 bg-transparent text-sm text-[#A2A6AE] placeholder:text-[#A2A6AE] focus:outline-none ${interClass}`}
                  placeholder={t("couponCode")}
                  value={orderData?.couponCode || couponCode}
                  disabled={!!orderData?.couponCode}
                  onChange={(e) => {
                    setCouponCodeError("");
                    setCouponCode(CUSTOM.strFormat(e.target.value, "max:30"));
                  }}
                />
              </div>
              {orderData?.couponCode ? (
                <button
                  onClick={removeCouponCode}
                  className={`px-5 py-2 ${interClass} rounded-full text-sm font-medium text-[#BD0043] hover:opacity-90 transition whitespace-nowrap`}
                >
                  {t("Remove") || "Remove"}
                </button>
              ) : (
                <button
                  onClick={() => {
                    setCouponCodeError("");
                    if (couponCode) applyCouponCode();
                  }}
                  className={`bg-[#7b1736] text-white px-5 py-2 ${interClass} rounded-full text-sm font-medium hover:opacity-90 transition whitespace-nowrap`}
                >
                  {t("applyCoupon") || "Apply"}
                </button>
              )}
            </div>
            {couponCodeError ? (
              <span className="red-error text-xs text-red-500 mt-1 block">{couponCodeError}</span>
            ) : null}
          </div>
        )}

        {/* ── Order Summary — Cart style ── */}
        <div className="px-4 py-4 border-t border-gray-200">
          <Text className={`text-black ${headingClass} text-lg font-medium leading-6 mb-3`}>
            {t("orderSummary")}
          </Text>

          <div className="space-y-2">
            {/* Subtotal */}
            <div className="flex justify-between text-sm">
              <Text
                className={`text-center ${interClass} text-base font-normal leading-6`}
                style={{ color: "var(--Blacks-400, #727783)" }}
              >
                {t("productsubtotal")}
              </Text>
              <div className="flex items-center gap-2">
                <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                <Text
                  className={`${headingClass} text-base font-medium leading-6`}
                  style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                >
                  {t("sar")} {CUSTOM.setPrice(orderSummary?.sub_total)}
                </Text>
              </div>
            </div>

            {/* Delivery Fee */}
            {orderSummary?.delivery_fees ? (
              <div className="flex justify-between text-sm">
                <Text
                  className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}
                >
                  {t("deliveryFee")}
                </Text>
                <div className="flex flex-row items-center justify-end gap-2">
                  <HtmlTooltip
                    placement="top-start"
                    arrow
                    title={
                      <div className="bg-white-A700 py-3 px-5 rounded-lg shadow-lg -ml-5">
                        <Text className="leading-5 text-black text-sm font-medium">
                          {t("dropzonediscount")}
                        </Text>
                      </div>
                    }
                  >
                    <div>
                      <Img src="/images/img_info-black.svg" className="w-4 h-4 mr-1.5 cursor-pointer" alt="info" />
                    </div>
                  </HtmlTooltip>
                  <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                  <Text
                    className={`text-center ${headingClass} text-base font-medium leading-6`}
                    style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                  >
                    <span className={orderSummary?.pickup_discount ? "line-through" : ""}>
                      {t("sar")} {CUSTOM.setPrice(orderSummary?.delivery_fees)}
                    </span>
                    {orderSummary?.pickup_discount ? (
                      <span className="text-teal-400 whitespace-nowrap font-medium font-nunitoregular text-xs leading-4 text-end">
                        {" "}{t("sar")}{" "}
                        {CUSTOM.setPrice(orderSummary?.delivery_fees - orderSummary?.pickup_discount)}
                      </span>
                    ) : null}
                    {orderSummary?.pickup_discount
                      ? ` (-${orderSummary?.pickupDiscountPercent}%)`
                      : ""}
                  </Text>
                </div>
              </div>
            ) : null}

            {/* Timeslot Discount */}
            {orderSummary?.timeslot_discount ? (
              <div className="flex justify-between text-sm">
                <Text
                  className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}
                >
                  Timeslot Discount
                </Text>
                <Text className="text-green-600 font-medium">
                  {t("sar")} {" - "}{CUSTOM.setPrice(orderSummary?.timeslot_discount)}
                </Text>
              </div>
            ) : null}

            {/* VAT */}
            {orderSummary?.vat ? (
              <div className="flex justify-between text-sm">
                <Text
                  className={`text-center ${interClass} text-base font-normal leading-6`}
                  style={{ color: "var(--Blacks-400, #727783)" }}
                >
                  {t("taxVAT")}
                </Text>
                <div className="flex items-center gap-2">
                  <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                  <Text
                    className={`text-center ${headingClass} text-base font-medium leading-6`}
                    style={{ color: "var(--Blacks-900, #1A1A1A)" }}
                  >
                    {t("sar")} {CUSTOM.setPrice(orderSummary?.vat)}
                  </Text>
                </div>
              </div>
            ) : null}

            {/* Coupon Discount */}
            {orderSummary?.coupon_discount ? (
              <div className="flex justify-between text-sm">
                <Text className="text-gray-700">{t("couponDiscount")}</Text>
                <div className="flex items-center gap-2">
                  <Img src="/images/Groupsar2.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
                  <Text className="text-green-600 font-medium">
                    - {t("sar")} {CUSTOM.setPrice(orderSummary?.coupon_discount)}
                  </Text>
                </div>
              </div>
            ) : null}

            {/* Pickup Discount — commented out, tooltip already covers it above */}
            {/* {orderSummary?.pickup_discount ? (
              <div className="flex flex-row items-center justify-between">
                <Text className="text-gray-700 ..."> {t("dropzonediscount")} </Text>
                <Text className="text-teal-400 ...">
                  - {t("sar")} {CUSTOM.setPrice(orderSummary?.pickup_discount)}
                </Text>
              </div>
            ) : null} */}
          </div>

          {/* Total — Cart style: #771237 bold Unbounded */}
          <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-300">
            <Text className={`text-black-900 ${interClass} text-base`}>
              {t("totalAmount")}
            </Text>
            <div className="flex items-center gap-2">
              <Img src="/images/Groupsar.svg" alt="sar" className="w-[14px] h-[14px] object-contain" />
              <Text className={`text-[#771237] font-bold ${headingClass} text-lg`}>
                {t("sar")} {CUSTOM.setPrice(orderSummary?.total_amount)}
              </Text>
            </div>
          </div>
        </div>
          </>
        )}
      </div>

      {/* ── OLD UI — commented for reference ──
      <div className="max-w-[350px] w-full sm:pl-0 xs:pl-0 sm:max-w-full sm:order-1">
        <div className="bg-white-A700 w-full">
          <div className="py-1 px-5 py-4">
            ... (original markup preserved in git history)
          </div>
        </div>
      </div>
      */}
    </ContentWrapper>
  );
};

export default CartProductDetail;
